import type { MarkdownIt } from "react-native-markdown-display";

export type CalloutVariant = "task" | "scenario";

const MARKER_RE = /^\s*\[!(TASK|SCENARIO)\]\s*\n?/i;

export function calloutPlugin(md: MarkdownIt): void {
  md.core.ruler.after("block", "callout", (state) => {
    const { tokens } = state;
    for (let i = 0; i < tokens.length; i++) {
      const blockquoteOpen = tokens[i];
      if (blockquoteOpen.type !== "blockquote_open") continue;

      const inline = tokens[i + 2];
      if (!inline || inline.type !== "inline" || typeof inline.content !== "string") continue;

      const match = inline.content.match(MARKER_RE);
      if (!match) continue;

      const variant = match[1].toLowerCase() as CalloutVariant;
      blockquoteOpen.meta = { ...(blockquoteOpen.meta ?? {}), callout: variant };

      inline.content = inline.content.slice(match[0].length);
    }
  });
}
